import React from 'react';

const partners = [
  { name: 'Von Kommunikasjon', logo: 'https://customer-assets.emergentagent.com/job_upscale-blue/artifacts/236qzv42_Von%20logo.png' },
  { name: 'Ymir Labs', logo: 'https://customer-assets.emergentagent.com/job_upscale-blue/artifacts/z2l778u2_Ymir%20logo.png' },
  { name: 'Crowd Multiplier', logo: 'https://customer-assets.emergentagent.com/job_upscale-blue/artifacts/flvebfd5_Crowd%20multiplier%20logo.png' },
  { name: 'Eclat Interactive', logo: 'https://customer-assets.emergentagent.com/job_upscale-blue/artifacts/77lhgn28_Eclat%20Logo.png' }
];

const PartnersSection = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900">
            Partners & <span className="text-blue-600">Advisors</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 items-center">
          {partners.map((partner, index) => (
            <div
              key={index}
              className="flex items-center justify-center p-6 bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105 cursor-pointer"
            >
              <img
                src={partner.logo}
                alt={partner.name}
                className="w-full h-auto opacity-60 hover:opacity-100 transition-opacity duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;